import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای درون‌ریزی متریال‌ها

در این فرم می‌توانید لیستی از مواد اولیه یا قطعات را از طریق فایل اکسل به سیستم اضافه یا به‌روزرسانی کنید.

## ۱. دانلود قالب
ابتدا قالب استاندارد اکسل را دانلود کرده و اطلاعات متریال‌ها را در آن پر کنید.

## ۲. بارگذاری
فایل تکمیل شده را بارگذاری کنید. سیستم قبل از ثبت نهایی، خطاها و مغایرت‌های احتمالی فایل را بررسی و به شما نمایش می‌دهد.

export default Layout;
